import { attributionSettingsSchema } from "@redotech/redo-attribution-common/attribution-settings";

export const updateAttributionSettings = {
  name: "updateAttributionSettings" as const,
  input: attributionSettingsSchema,
  output: attributionSettingsSchema,
};
